import { Box, Spinner } from '@fullstory/components';
import { GetAPIEventDetailViewResponse } from '@fullstory/proto/fs/services/dx-objects';
import React, { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import { APIEventDetails } from '../APIEventDetails';

type SidebarAPIEventProps = Omit<ComponentProps<typeof APIEventDetails>, 'issues'> & {
  details: GetAPIEventDetailViewResponse.Details | null;
};

export const SidebarAPIEvent: React.FC<SidebarAPIEventProps> = ({ details, ...props }) => {
  const intl = useIntl();

  if (!details) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" testId="sidebar-api-spinner">
        <Spinner />
      </Box>
    );
  }

  return (
    <APIEventDetails
      data-component="SidebarEvent"
      issues={details.issuesData?.issues || []}
      header={intl.formatMessage({ defaultMessage: 'View Event', id: 'gjfMRr' })}
      {...props}
    />
  );
};
